import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Splashscreen",
    meta: {
      title: "Splashscreen"
    },
    component: () =>
      import(/* webpackChunkName: "splashscreen" */ "../views/SplashScreen.vue")
  },
  {
    path: "/guided",
    name: "Guided mode",
    meta: {
      title: "Guided"
    },
    component: () =>
      import(/* webpackChunkName: "splashscreen" */ "../views/GuidedMode.vue")
  },
  {
    path: "/breakdown",
    name: "Breakdown",
    meta: {
      title: "Breakdown"
    },
    component: () =>
      import(/* webpackChunkName: "splashscreen" */ "../views/Breakdown.vue")
  },
  {
    path: "/expert-mode",
    name: "Expert Mode",
    meta: {
      title: "Expert Mode"
    },
    component: () =>
      import(/* webpackChunkName: "splashscreen" */ "../views/ExpertMode.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
